export type SITE_IDS = "main_pt" | "main_en";

const sites: Record<string, SITE_IDS> = {
  "ligaport.app": "main_pt",
  "en.ligaport.app": "main_en",
  "ligaport.staging.ismgames.com": "main_pt",
  "en.ligaport.staging.ismgames.com": "main_en",
  "fantasy.ligaportugal.pt": "main_pt",
  "en.fantasy.ligaportugal.pt": "main_en",
};

export const getSite = () => sites[window.location.hostname] || "";
